module.exports = __webpack_public_path__ + "img/Maskgroup.87b76413.svg";